<div id="ALARMS" style="padding: 10px;">
  <app-log-select header=" Alarms Summary " 
    [showSites]="true"
    [MultiSites]="true"
    [showDaterange]="false"
    [showLocation]="false"
    [Date_time]="true"
    [AllSelection]="true"
    [filterConfig]="FILTER_CONFIG"
    [timeDuration]="7200"
    (filtersApplied)="handleFilters($event)" (showTable)="handlereset($event)">
    </app-log-select>
    <div class="aoc-dashboard" style="padding: 1px; border-radius: 17px;" *ngIf="showReport">
  
  
      <!-- CONTENT -->
      <div class="aoc-content" >
  
        <!-- SUMMARY METRICS -->
        <div class="aoc-section-header">
          <span class="aoc-section-title">Summary</span>
        </div>
        <div class="stats-grid" [attr.data-count]="statCards.length">
          @for (data of statCards; track data.id) {
            <div class="custom-col" [class.few-items]="statCards.length > 5">
              <div class="card-anim-wrapper"
                  class=""
                  id="{{ data.key }}">
                <div class="card o-hidden small-widget"
                    (click)="switchTab(data.clicktype,data.focus||data.tableAPI,data.title)"
                    [ngStyle]="{ cursor: data?.key ? 'pointer' : 'default' }">
                  <div class="card-body {{ data.class1 }} {{ data.key }}">
                    <h5 class="f-w-600 f-14 custom-div-prop">{{ data.title }} :</h5>
  
                    <div class="project-details">
                      <div class="project-counter">
                        <h3 class="f-w-600 z-1"
                            placement="bottom">
                          {{ data.total }}
                        </h3>
                      </div>
                      <div class="product-sub bg-{{ data.class2 }}-light"
                          [class.few-items]="statCards.length > 5">
                        <img class="img-20" src="{{ data.imagepath }}" />
                      </div>
                    </div>
  
                    <ul class="bubbles">
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                      <li class="bubble"></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
  <!-- ── Critical Alarms Accordion ─────────────────────────────────────────────
     Place this block BETWEEN the top stat-cards and the Trends & Distribution
     section header in alarm-dashboard.component.html
──────────────────────────────────────────────────────────────────────────── -->

<!-- ── Critical Alarms Accordion — server-paginated ───────────────────────── -->

<div class="aoc-accordion" [class.aoc-accordion--open]="criticalOpen">

  <!-- ── Header / Toggle bar ── -->
  <button class="aoc-accordion__trigger"
          (click)="toggleCritical()"
          [attr.aria-expanded]="criticalOpen"
          aria-controls="critical-panel">

    <div class="aoc-accordion__trigger-left">
      <span class="aoc-accordion__alert-dot" aria-hidden="true"></span>
      <span class="aoc-accordion__title">Critical Alarms</span>
      <span class="aoc-accordion__count-badge">
        {{ criticalTotalCount | number }} total
      </span>
    </div>

    <div class="aoc-accordion__trigger-right">
      <span class="aoc-accordion__sev-pill aoc-accordion__sev-pill--p1"
            [ngbTooltip]="'Priority 1 — Immediate action required'">
        P1 · {{ p1Count }}
      </span>
      <span class="aoc-accordion__sev-pill aoc-accordion__sev-pill--p2"
            [ngbTooltip]="'Priority 2 — Action required soon'">
        P2 · {{ p2Count }}
      </span>
      <svg class="aoc-accordion__chevron"
           viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.2"
           stroke-linecap="round" stroke-linejoin="round"
           aria-hidden="true">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </div>
  </button>

  <!-- ── Collapsible panel ── -->
  <div class="aoc-accordion__panel"
       id="critical-panel"
       role="region"
       [attr.aria-hidden]="!criticalOpen">

    <div class="aoc-accordion__panel-inner">

      <!-- ── Toolbar ── -->
      <div class="aoc-accordion__toolbar">

        <!-- Severity tabs — client-side filter on current page slice -->
        <div class="aoc-filter-tabs">
          <button class="aoc-filter-tab"
                  *ngFor="let f of criticalSevFilters"
                  [class.aoc-filter-tab--active]="criticalSevFilter === f.key"
                  (click)="setCriticalSevFilter(f.key)">
            {{ f.label }}
          </button>
        </div>
        <!-- Page-size selector -->
        <div class="aoc-accordion__device-filter">
          <select class="aoc-accordion__select"
                  [(ngModel)]="criticalPageSize"
                  (ngModelChange)="setCriticalPage(1)">
            <option [value]="8">8 / page</option>
            <option [value]="15">15 / page</option>
            <option [value]="25">25 / page</option>
          </select>
        </div>

      </div><!-- /toolbar -->

      <!-- ── Loading spinner ── -->
      <div class="aoc-table-state" *ngIf="isCriticalLoading">
        <span class="aoc-table-state__spinner" aria-label="Loading…"></span>
        <span>Loading critical alarms…</span>
      </div>

      <!-- ── Error state ── -->
      <div class="aoc-table-state aoc-table-state--error"
           *ngIf="!isCriticalLoading && criticalError">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        {{ criticalError }}
      </div>

      <!-- ── Table ── -->
      <div class="aoc-accordion__table-wrap"
          *ngIf="!isCriticalLoading && !criticalError">
        <table class="aoc-accordion__table">
          <thead>
            <tr>
              <th>Priority</th>
              <th *ngFor="let col of criticalHeaders">{{ col.name }}</th>
            </tr>
          </thead>
          <tbody>

            <tr *ngIf="filteredCritical.length === 0">
              <td [attr.colspan]="criticalHeaders.length + 1"
                  class="aoc-accordion__empty">
                No critical alarms match the current filter.
              </td>
            </tr>

            <tr *ngFor="let alarm of filteredCritical"
                class="aoc-accordion__row aoc-accordion__row--{{ alarm.priority }}">

              <td>
                <span class="aoc-accordion__priority aoc-accordion__priority--{{ alarm.priority }}">
                  {{ alarm.priority | uppercase }}
                </span>
              </td>

              <td *ngFor="let col of criticalHeaders">
                {{ alarm._raw[col.key] ?? '—' }}
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <!-- ── Pagination ── -->
      <div class="aoc-accordion__pagination"
           *ngIf="!isCriticalLoading && !criticalError && criticalTotalCount > criticalPageSize">

        <!-- Prev -->
        <button class="aoc-accordion__page-btn"
                [disabled]="criticalCurrentPage === 1"
                (click)="setCriticalPage(criticalCurrentPage - 1)"
                aria-label="Previous page">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>

        <!-- Page numbers -->
        <ng-container *ngFor="let p of criticalPageNumbers">
          <!-- Ellipsis gap -->
          <span class="aoc-accordion__page-gap"
                *ngIf="p !== 1 && p !== criticalCurrentPage
                       && criticalPageNumbers.indexOf(p) > 0
                       && p - criticalPageNumbers[criticalPageNumbers.indexOf(p) - 1] > 1">
            …
          </span>
          <button class="aoc-accordion__page-btn"
                  [class.aoc-accordion__page-btn--active]="p === criticalCurrentPage"
                  (click)="setCriticalPage(p)">
            {{ p }}
          </button>
        </ng-container>

        <!-- Next -->
        <button class="aoc-accordion__page-btn"
                [disabled]="criticalCurrentPage === criticalTotalPages"
                (click)="setCriticalPage(criticalCurrentPage + 1)"
                aria-label="Next page">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </button>

        <!-- Range label -->
        <span class="aoc-accordion__page-info">
          {{ criticalPageStart }}–{{ criticalPageEnd }}
          of {{ criticalTotalCount | number }}
        </span>

      </div><!-- /pagination -->

    </div><!-- /panel-inner -->
  </div><!-- /panel -->
</div><!-- /accordion -->
<!-- /accordion -->
        <!-- TREND + DONUT -->
        <div class="aoc-section-header">
          <span class="aoc-section-title">Trends &amp; Distribution</span>
        </div>
    <div class="aoc-charts-row">
      <!-- Alarms over time - Line Chart (Hourly) -->
      <div class="aoc-chart-card">
        <div class="aoc-chart-card__header">
          <div>
            <div class="aoc-chart-card__title">Alarm Overtime Trend</div>
            <div class="aoc-chart-card__sub">Hourly count · Grid / DG / Others</div>
          </div>
        </div>
        <div class="aoc-chart-wrap">
          <apx-chart
            [series]="trendChartOptions.series"
            [chart]="trendChartOptions.chart"
            [xaxis]="trendChartOptions.xaxis"
            [yaxis]="trendChartOptions.yaxis"
            [stroke]="trendChartOptions.stroke"
            [colors]="trendChartOptions.colors"
            [grid]="trendChartOptions.grid"
            [tooltip]="trendChartOptions.tooltip"
          ></apx-chart>
        </div>
      </div>
  
      <!-- Category split - Donut Chart -->
      <div class="aoc-chart-card">
        <div class="aoc-chart-card__header">
          <div>
            <div class="aoc-chart-card__title">Category split</div>
            <div class="aoc-chart-card__sub">By alarm group</div>
          </div>
        </div>
        <!-- <div class="aoc-legend-pills">
          <div class="aoc-legend-pill" *ngFor="let item of pieCategories">
            <span class="aoc-legend-dot" [style.background]="item.color"></span>{{ item.label }}
          </div>
        </div> -->
        <div class="aoc-chart-wrap aoc-chart-wrap--sm">
          <apx-chart
            [series]="pieChartOptions.series"
            [chart]="pieChartOptions.chart"
            [labels]="pieChartOptions.labels"
            [colors]="pieChartOptions.colors"
            [legend]="pieChartOptions.legend"
            [plotOptions]="pieChartOptions.plotOptions"
          ></apx-chart>
        </div>
      </div>
    </div>
  
    <!-- BREAKDOWN -->
    <div class="aoc-section-header">
      <span class="aoc-section-title">Breakdown</span>
    </div>
    <div class="aoc-charts-row3">
  
      <!-- Top alarm types hbar — Grid / DG / Others -->
      <div class="aoc-chart-card">
        <div class="aoc-chart-card__header">
          <div>
            <div class="aoc-chart-card__title">Top alarm types</div>
            <div class="aoc-chart-card__sub">By frequency</div>
          </div>
          <div class="aoc-filter-tabs">
            <button class="aoc-filter-tab"
                    [class.aoc-filter-tab--active]="hbarFilter === f.key"
                    *ngFor="let f of hbarFilters"
                    (click)="setHbarFilter(f.key)">{{ f.label }}</button>
          </div>
        </div>
        
          <div class="aoc-hbar-scroll">
            <div class="aoc-hbar-list">
              <div class="aoc-hbar-row" *ngFor="let bar of filteredBars">
                <div class="aoc-hbar-label" [title]="bar.label">{{ bar.label }}</div>
                <div class="aoc-hbar-track">
                  <div class="aoc-hbar-fill"
                      [style.width]="(bar.count / maxBarCount * 100) + '%'"
                      [style.background]="sevColors[bar.sev]"></div>
                </div>
                <div class="aoc-hbar-count">{{ bar.count }}</div>
              </div>
            </div>
          </div>
      </div>
  
      <!-- Alarms by hour - Bar Chart -->
      <!-- <div class="aoc-chart-card">
        <div class="aoc-chart-card__header">
          <div>
            <div class="aoc-chart-card__title">Alarms by hour</div>
            <div class="aoc-chart-card__sub">Peak activity hours</div>
          </div>
        </div>
        <div class="aoc-chart-wrap">
          <apx-chart
            [series]="hourChartOptions.series"
            [chart]="hourChartOptions.chart"
            [xaxis]="hourChartOptions.xaxis"
            [yaxis]="hourChartOptions.yaxis"
            [plotOptions]="hourChartOptions.plotOptions"
            [colors]="hourChartOptions.colors"
            [grid]="hourChartOptions.grid"
            [dataLabels]="hourChartOptions.dataLabels"
          ></apx-chart>
        </div>
      </div> -->
  
      <!-- By device type - Bar Chart -->
      <div class="aoc-chart-card">
        <div class="aoc-chart-card__header">
          <div>
            <div class="aoc-chart-card__title">By device type</div>
            <div class="aoc-chart-card__sub">{{ deviceStats.length }} device type(s)</div>
          </div>
        </div>
        <div class="aoc-chart-wrap aoc-chart-wrap--sm">
          <apx-chart
            [series]="deviceChartOptions.series"
            [chart]="deviceChartOptions.chart"
            [xaxis]="deviceChartOptions.xaxis"
            [yaxis]="deviceChartOptions.yaxis"
            [plotOptions]="deviceChartOptions.plotOptions"
            [colors]="deviceChartOptions.colors"
            [dataLabels]="deviceChartOptions.dataLabels"
          ></apx-chart>
        </div>
<!-- device breakdown button + popover -->
<div class="aoc-device-popover-host">
  <div class="aoc-device-popover" [class.aoc-device-popover--open]="deviceStatsOpen">
    <div class="aoc-device-popover__title">Device breakdown</div>
    <div class="aoc-device-stat" *ngFor="let d of deviceStats">
      <span class="aoc-device-stat__name">
        <span class="aoc-device-stat__dot" [style.background]="d.color"></span>
        {{ d.name }}
      </span>
      <div class="aoc-device-stat__bar">
        <div class="aoc-device-stat__fill"
             [style.width]="d.pct + '%'"
             [style.background]="d.color"></div>
      </div>
      <span class="aoc-device-stat__val">{{ d.count | number }}</span>
    </div>
  </div>

  <button class="aoc-device-stats-btn" (click)="deviceStatsOpen = !deviceStatsOpen">
    <span><i class="ti ti-devices" aria-hidden="true"></i> Breakdown by device</span>
    <i class="ti" [class.ti-chevron-up]="deviceStatsOpen" [class.ti-chevron-down]="!deviceStatsOpen" aria-hidden="true"></i>
  </button>
</div>
      </div>
    </div>
  
        <!-- RECENT ALARMS TABLE -->
        <div class="aoc-table-card" api_focus="site_list">
          <div class="aoc-table-wrap" *ngIf="!isLoading && !apiError">
                <app-table [pageNation]="true" [paginationPageSizeSelector]="[10,20,50]" [maxRowCount]="totalCount"  (onPageChange)="handlePageChange($event)"></app-table>
          </div>
        </div>
  
      </div><!-- /content -->
    </div>
</div>